module.exports = __webpack_public_path__ + "img/logo_admin_min.d9b37774.svg";